export default {"src":"/_next/static/media/kluisjes.3fa1f07d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};